module.exports = __webpack_public_path__ + "img/Frame_4.abb36a2c.png";